/**
 * Auth Login Page Logic
 */
export function initLogin() {
    initCaptchaRefresh();
    initPasswordToggle();
    initCustomValidation();
    initCursorGlow();
}

function initPasswordToggle() {
    const togglePw = document.getElementById('togglePw');
    if (togglePw) {
        togglePw.addEventListener('click', function () {
            var input = document.getElementById('passwordInput');
            var icon = document.getElementById('togglePwIcon');
            if (input.type === 'password') {
                input.type = 'text';
                icon.className = 'bi bi-eye-slash';
            } else {
                input.type = 'password';
                icon.className = 'bi bi-eye';
            }
        });
    }
}

function initCaptchaRefresh() {
    const refreshBtn = document.getElementById('refresh-captcha');
    if (refreshBtn) {
        refreshBtn.addEventListener('click', function (e) {
            e.preventDefault();
            var wrapper = document.getElementById('captcha-wrapper');
            var url = wrapper.getAttribute('data-refresh-url');
            var icon = this.querySelector('i');
            var btn = this;

            if (!url) return;

            icon.style.transition = 'transform 0.5s ease';
            icon.style.transform = 'rotate(360deg)';
            btn.disabled = true;

            fetch(url, {
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
            })
                .then(function (r) { return r.json(); })
                .then(function (data) {
                    var img = wrapper.querySelector('img');
                    if (img && data.image) {
                        img.src = data.image;
                    } else if (data.image) {
                        wrapper.innerHTML = `<img src="${data.image}" alt="CAPTCHA">
                                             <button type="button" class="btn-refresh" id="refresh-captcha" title="Refresh CAPTCHA">
                                                <i class="bi bi-arrow-clockwise"></i>
                                             </button>`;
                    }
                    // Update captcha token hidden field
                    if (data.token) {
                        var tokenField = document.getElementById('captcha_token');
                        if (tokenField) {
                            tokenField.value = data.token;
                        }
                    }
                    setTimeout(function () {
                        if (icon) {
                            icon.style.transform = 'rotate(0deg)';
                            icon.style.transition = 'none';
                        }
                    }, 500);
                    btn.disabled = false;
                })
                .catch(function (err) {
                    console.error('Captcha refresh error:', err);
                    btn.disabled = false;
                    if (icon) icon.style.transform = 'rotate(0deg)';
                });
        });
    }
}

/**
 * Custom form validation with inline Indonesian error messages
 * Replaces browser-native "Please fill out this field." tooltip
 */
function initCustomValidation() {
    const loginForm = document.getElementById('loginForm');
    if (!loginForm) return;

    // Disable browser native validation tooltips
    loginForm.setAttribute('novalidate', 'true');

    // Validation rules map (field name -> Indonesian message)
    const validationMessages = {
        'login': 'Silakan masukkan username atau email Anda.',
        'password': 'Silakan masukkan password Anda.',
        'captcha': 'Silakan masukkan kode verifikasi.'
    };

    // Clear error when user starts typing
    loginForm.querySelectorAll('input').forEach(function (input) {
        input.addEventListener('input', function () {
            clearFieldError(this);
        });
        input.addEventListener('focus', function () {
            clearFieldError(this);
        });
    });

    // Handle form submission
    loginForm.addEventListener('submit', function (e) {
        // Clear all previous errors
        loginForm.querySelectorAll('.field-error').forEach(function (el) {
            el.remove();
        });
        loginForm.querySelectorAll('.input-field.is-invalid').forEach(function (el) {
            el.classList.remove('is-invalid');
        });

        let firstInvalid = null;
        let isValid = true;

        // Check each required field
        loginForm.querySelectorAll('input[required]').forEach(function (input) {
            if (!input.value.trim()) {
                isValid = false;
                showFieldError(input, validationMessages[input.name] || 'Harap isi bidang ini.');
                if (!firstInvalid) firstInvalid = input;
            }
        });

        if (!isValid) {
            e.preventDefault();
            if (firstInvalid) firstInvalid.focus();
            return;
        }

        // Form is valid — show loading state
        var btn = document.getElementById('btnLogin');
        if (btn) {
            btn.disabled = true;
            btn.innerHTML = '<span class="spinner"></span> Memverifikasi...';
        }
    });
}

function showFieldError(input, message) {
    input.classList.add('is-invalid');

    // Find the parent .field element
    var fieldContainer = input.closest('.field');
    if (!fieldContainer) return;

    // Create error message element
    var errorEl = document.createElement('div');
    errorEl.className = 'field-error';
    errorEl.innerHTML = '<i class="bi bi-exclamation-circle"></i> ' + message;
    fieldContainer.appendChild(errorEl);
}

function clearFieldError(input) {
    input.classList.remove('is-invalid');
    var fieldContainer = input.closest('.field');
    if (!fieldContainer) return;
    var errorEl = fieldContainer.querySelector('.field-error');
    if (errorEl) errorEl.remove();
}

function initCursorGlow() {
    var glow = document.querySelector('.cursor-glow');
    if (glow) {
        document.addEventListener('mousemove', function (e) {
            var x = ((e.clientX / window.innerWidth) * 100).toFixed(1) + '%';
            var y = ((e.clientY / window.innerHeight) * 100).toFixed(1) + '%';
            glow.style.setProperty('--mx', x);
            glow.style.setProperty('--my', y);
        });
    }
}

